import { DEFAULT_RIBBON_HALFTONE_MATERIAL, SUBTLE_RIBBON_INTERACTION } from "../interaction";
import { LANDING_ENDCAP_ZOOM, LINE_SPACING, MATCHED_IDLE_SPEED, PAPER, PREVIOUS_BLOCK_TOP, REVEAL_SPACING, } from "./shared";
/** Patients keeps the same material and motion as Product, with a modest
 * clockwise lean, left bias, and broader vertical silhouette. */
export const PATIENTS_PRESET = {
    id: "patients",
    roles: ["settle"],
    mobileBreakpoint: 900,
    palette: "primary-v2",
    shape: "line",
    halftone: DEFAULT_RIBBON_HALFTONE_MATERIAL,
    interaction: SUBTLE_RIBBON_INTERACTION,
    curveProfile: {
        viewportSpan: 0.43,
        xCheckpoints: [0.19, 0.61, 0.41],
        bendWindows: [0.1, 0.4, 0.64, 0.9],
        mobile: { viewportSpan: 0.31, xCheckpoints: [0.2, 0.59, 0.41] },
    },
    initialStateId: "patient-welcome",
    states: [
        {
            id: "patient-welcome",
            background: PAPER,
            zoom: 0.76,
            ribbonWidthScale: 0.86,
            halftoneApparentZoom: LANDING_ENDCAP_ZOOM,
            center: [0.36, 0.52],
            rotationDeg: -94,
            lineExtent: 0.5,
            turbulence: 0.22,
            spacing: REVEAL_SPACING,
            speed: MATCHED_IDLE_SPEED,
            dither: 1,
            spatialColor: 0.11,
            twistRetention: 0.93,
            fanSpread: 0.017,
            twistSpread: 0.034,
            horizontalStretch: 1.38,
            unravel: 0.52,
            curveStrength: 0.62,
            curveProgress: 0.12,
            mobile: {
                zoom: 0.42,
                center: [0.37, 0.52],
                rotationDeg: -93,
                lineExtent: 0.7,
                ribbonWidthScale: 0.86,
                fanSpread: 0.01,
                twistSpread: 0.021,
                horizontalStretch: 1.16,
                curveStrength: 0.48,
            },
        },
        {
            id: "patient-path",
            background: PAPER,
            zoom: 0.74,
            ribbonWidthScale: 0.84,
            halftoneApparentZoom: LANDING_ENDCAP_ZOOM,
            center: [0.47, 0.51],
            rotationDeg: -87,
            lineExtent: 0.54,
            turbulence: 0.14,
            spacing: LINE_SPACING,
            speed: MATCHED_IDLE_SPEED,
            dither: 1,
            spatialColor: 0.05,
            twistRetention: 0.98,
            fanSpread: 0.005,
            twistSpread: 0.009,
            horizontalStretch: 1.06,
            unravel: 0.16,
            curveStrength: 0.14,
            curveProgress: 0.55,
            mobile: {
                zoom: 0.41,
                center: [0.47, 0.51],
                rotationDeg: -87,
                lineExtent: 0.72,
                ribbonWidthScale: 0.84,
                curveStrength: 0.11,
            },
        },
    ],
    steps: [
        {
            role: "settle",
            stateId: "patient-path",
            start: PREVIOUS_BLOCK_TOP,
            end: { target: "top", viewport: 0.25 },
        },
    ],
};
//# sourceMappingURL=patients.js.map